module.exports = __webpack_public_path__ + "img/pic.4815b835.png";